// One clock for every animated part of the stats bento, so the tiles, the
// counting figures, the bar chart and the uptime strip all read as a single
// gesture instead of six unrelated ones.
//
// Deliberately NOT a "use client" module: StatsSection is a Server Component and
// needs to call `innerDelay()` while rendering. Anything exported from a client
// module becomes a client reference and cannot be called on the server.

// Gap between consecutive tiles arriving. `reveal.js` reads this too, so the
// cards and their contents stagger off the same number.
export const CARD_STAGGER = 0.09;

// Content inside a tile waits for its own tile to arrive first — the extra beat
// is what stops the whole bento firing at once.
export const innerDelay = (index = 0) => index * CARD_STAGGER + 0.15;

// A figure counting up to its value.
export const COUNT = { duration: 1.2, ease: "easeOut" };

// Bars growing out of the baseline, left to right.
export const BAR = { duration: 0.7, stagger: 0.06, ease: "easeOut" };

// The twelve uptime squares. Short and tight — twelve slow cells would read as
// a toy rather than a record of continuous service.
export const CELL = { duration: 0.3, stagger: 0.03, ease: "easeOut" };

// The uptime squares' resting tone, matched to the design. It lives here rather
// than in a class because the animation has to end on it.
export const CELL_OPACITY = 0.9;
